import { z } from "zod";
import { optionalCommentTextSchema } from "../comment/models.js";

export default {
  params: z.object({
    accountId: z.string(),
    beneficiaryName: z.string().min(1),
    beneficiaryIban: z.string().min(1),
    amount: z.number().positive(),
    label: z.string().optional(),
    reference: z.string().optional(),
    verificationOfPayee: z
      .enum(["CloseMatch", "Match", "NoMatch", "VerificationNotPossible"])
      .optional(),
    comment: optionalCommentTextSchema,
    trackedCategoryId: z.string().optional(),
  }),
  response: z.object({
    transferId: z.string(),
  }),
};
